import "./ThemeToggle.css";
import { FaSun, FaMoon } from "react-icons/fa";

export function ThemeToggle({ handleChange, isDark }) {
    return (
        <button
            className="themeToggle"
            onClick={handleChange}
            aria-label={isDark ? "Enable light mode." : "Enable dark mode."}
            title={isDark ? "Enable light mode" : "Enable dark mode"}
        >
            {isDark ? <FaSun /> : <FaMoon />}
        </button>
    );
}
